import { AccessValidation } from "@/components/AccessValidation";
import { useNavigate } from "react-router-dom";

export const AccessValidationPage = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");
  return <AccessValidation onBack={handleBack} />;
};
